import Image from '@/components/Image/image';
import './portfolio-banner.scss';
import { PortfolioDetailData } from '@/data/portfolio/portfolio-detail-data';
import useDeviceSize from '@/hooks/useDeviceSize';
import { useMemo } from 'react';
import { motion } from 'motion/react';

type Props = {
	banner: PortfolioDetailData['banner'];
};

const PortfolioBanner = ({ banner }: Props) => {
	const {
		backgroundImage,
		logoImage,
		logoSize,
		shaderOpacity = 0.3
	} = banner;
	const { deviceSize } = useDeviceSize();

	const convertedLogoSize = useMemo(() => {
		if (deviceSize === 'pc') {
			return logoSize.pc;
		}
		if (deviceSize === 'tablet') {
			return logoSize.tablet;
		}
		if (deviceSize === 'mobile') {
			return logoSize.mobile;
		}
		return logoSize.pc;
	}, [deviceSize, logoSize]);

	return (
		<div className="portfolio-banner-wrapper">
			<div className="image-shader" style={{ opacity: shaderOpacity }} />

			<Image
				className="banner-img"
				src={backgroundImage}
				alt={logoImage}
				draggable={false}
			/>
			<div className="banner-content-box">
				<motion.div
					initial={{ opacity: 0, y: 50 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, ease: 'easeOut' }}
					className="banner-title-wrapper"
				>
					<img
						className="banner-logo"
						src={logoImage}
						alt={logoImage}
						draggable={false}
						width={convertedLogoSize.width}
						height={convertedLogoSize.height}
					/>
				</motion.div>
			</div>
		</div>
	);
};

export default PortfolioBanner;
